import { object, mixed, number } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

export const getValidationSchema = () => object({
  customSpotStep: mixed()
    .when(['spotStep', 'customSpotStepType'], {
      is: (duration, type) => duration === 'custom' && type === 'minutes',
      then: number()
        .integer()
        .typeError(I18n.t('errors.messages.not_a_number'))
        .required()
        .min(5, I18n.t(
          'errors.messages.greater_than_or_equal_to',
          { count: `5 ${I18n.t('time.min_abbr')}` }
        ))
        .max(720, I18n.t(
          'errors.messages.less_than_or_equal_to',
          { count: `720 ${I18n.t('time.min_abbr')}` }
        ))
    })
    .when(['spotStep', 'customSpotStepType'], {
      is: (duration, type) => duration === 'custom' && type === 'hours',
      then: number()
        .integer()
        .typeError(I18n.t('errors.messages.not_a_number'))
        .required()
        .positive(I18n.t(
          'errors.messages.greater_than_or_equal_to',
          { count: `1 ${I18n.t('time.min_abbr')}` }
        ))
        .max(12, I18n.t(
          'errors.messages.less_than_or_equal_to',
          { count: `12 ${I18n.t('time.hours_abbr.one')}` }
        ))
    }),
})
